
































































import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import { addDays, addMonths, addYears, setDay } from '@/helpers/dateUtils';
import { getBusinessUnitsDashboard } from '@/services/dashboard';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import ApprovalPrescriptionCharts from './charts/approval-prescription-charts.vue';
import NewLostPatientChartsV2 from './charts/new-lost-patient-v2.vue';
import ProductionPrescriptionCharts from './charts/production-prescription-charts.vue';
import StatusPrescriptionCharts from './charts/status-prescription-charts.vue';
import UsersTranscriptionsCharts from './charts/users-transcriptions-charts.vue';

@Component({
  components: {
    UiSelectClients,
    ProductionPrescriptionCharts,
    UiDatePicker,
    UsersTranscriptionsCharts,
    ApprovalPrescriptionCharts,
    StatusPrescriptionCharts,
    NewLostPatientChartsV2
  },
})
export default class Dashboard extends BaseComponent {
  periodo: any = 'h';
  dateFrom: any = null;
  dateTo: any = null;  
  businessUnits: any[] = [];
  idsBusinessUnitsSelec = [];

  mounted() {
    this.onPeriodoChange(this.periodo);
    this.loadBusinessUnits();
  }

  @Watch('periodo')
  public onPeriodoChange(n) {
    if (n == 'h') {
      this.dateFrom = new Date().toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'o') {
      this.dateFrom = addDays(new Date(), -1).toISOString();
      this.dateTo = addDays(new Date(), -1).toISOString();
    } else if (n == 'u3') {
      this.dateFrom = addDays(new Date(), -3).toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'u7') {
      this.dateFrom = addDays(new Date(), -7).toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'u15') {
      this.dateFrom = addDays(new Date(), -15).toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'u1m') {
      this.dateFrom = addMonths(new Date(), -1).toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'm') {
      this.dateFrom = setDay(new Date(), 1).toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'ma') {
      this.dateFrom = setDay(addMonths(new Date(), -1), 1).toISOString();
      this.dateTo = addDays(setDay(new Date(), 1), -1).toISOString();
    } else if (n == 'u2m') {
      this.dateFrom = addMonths(new Date(), -2).toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'u3m') {
      this.dateFrom = addMonths(new Date(), -3).toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'u6m') {
      this.dateFrom = addMonths(new Date(), -6).toISOString();
      this.dateTo = new Date().toISOString();
    } else if (n == 'ua') {
      this.dateFrom = addYears(new Date(), -1).toISOString();
      this.dateTo = new Date().toISOString();
    }
  }

  public loadBusinessUnits(){
    getBusinessUnitsDashboard().subscribe(res =>{
      this.businessUnits = res;
      this.idsBusinessUnitsSelec = res.map(e => e.id);
    }, error => {
      this.showToastApiError(error);
    })
  }
}
